import { Icons } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import NotificationsDropDown from "shared/dropdowns/notifications";
import { setBreadCrumb } from "shared/redux/reducers/breadCrumbSlice";
import { GetNotificationsCountService } from "shared/services/notifications";
import { findScreenTitle } from "shared/utils/helper";
import BreadCrumb from "../breadCrumb";
import styles from "./style.module.scss";
import { GetQuestionsService } from "shared/services/questionnaire";
import { setQuestionsReducer } from "shared/redux/reducers/questions";
import { GetCountService } from "shared/services/general";
import { setCountReducer } from "shared/redux/reducers/count";

interface Props {
  openMobile: () => void;
  user: any;
}

function DashboardHeader({ openMobile, user }: Props) {
  const location = useLocation();
  const dispatch = useDispatch();

  const [showNotifications, setShowNotifications] = useState(false);
  const [count, setCount] = useState<number>(0);

  const handleGetUnReadNotificationsCount = () => {
    GetNotificationsCountService()
      .then(({ data }) => {
        setCount(data?.count);
      })
      .catch((err) => {});
  };

  const handleGetQuestions = () => {
    GetQuestionsService()
      .then(({ data }) => {
        dispatch(setQuestionsReducer({ questions: data }));
      })
      .catch((err) => {})
      .finally(() => {});
  };

  const handleGetCount = () => {
    GetCountService()
      .then(({ data }) => {
        dispatch(
          setCountReducer({
            complaints: data?.complaints_count,
            orgs: data?.orgs_count,
            req: data?.req_count,
          })
        );
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handleGetCount();
    handleGetQuestions();
    handleGetUnReadNotificationsCount();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(
      setBreadCrumb({
        crumbs: [
          {
            title: findScreenTitle(location.pathname),
          },
        ],
        prePath: location.pathname,
      })
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <div className={classNames(styles.topLevelContainer)}>
        <div className={classNames("w-full", styles.headerContainer)}>
          <div className={classNames("flex items-center gap-3")}>
            <Icons.Hamburger
              className={classNames(styles.hamburgerIcon)}
              onClick={openMobile}
            />
            <BreadCrumb />
          </div>
          <div className={classNames("relative")}>
            <div
              className={classNames(styles.notifyContainer)}
              onClick={() => {
                setShowNotifications(!showNotifications);
              }}
            >
              <Icons.Bell />
              {count ? <div className={classNames(styles.dot)} /> : null}
            </div>
            <NotificationsDropDown
              show={showNotifications}
              setShow={setShowNotifications}
              count={count}
              setCount={setCount}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardHeader;
